import { Injectable, Injector } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';

const urlLogin = '/api/construction-projects/v1/login';

@Injectable({ providedIn: 'root' })
export class LoginService {

  private apiCockpit: APISCockpit;

  constructor(public objInjector: Injector) {
    this.apiCockpit = objInjector.get(APISCockpit);
   }

  login(user: string, password: string) {
   return this.apiCockpit.authenticate(user, password,  urlLogin);
  }

}
